export default "__VITE_ASSET__TVRwYYv3__"